import type { StepScore } from '~/helpers/learner/session-view'
import { Check, TriangleAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '~/lib/utils'

/**
 * Le score d'une étape, dans la couleur de son verdict face au seuil : réussi,
 * non atteint, ou neutre quand le paquet ne déclare pas de seuil. Même rendu
 * sur l'accueil, la liste des étapes et le panneau de l'étape en cours (#90).
 */
function ScoreValue({ score }: { score: StepScore }) {
  const { t } = useTranslation()
  // Le verdict ne repose plus sur la couleur seule (RGAA 3.1) : une forme à
  // l'œil, un mot au lecteur d'écran.
  const Mark = score.passed == null ? null : score.passed ? Check : TriangleAlert
  return (
    <span className={cn(
      'inline-flex items-center gap-1 font-medium tabular-nums',
      score.passed == null
        ? 'text-foreground'
        : score.passed
          ? 'text-success-text'
          : 'text-warning-text',
    )}
    >
      {Mark && <Mark className="size-3" aria-hidden />}
      {score.raw}
      {score.max != null ? ` / ${score.max}` : ''}
      {score.passed != null && <span className="sr-only">{` (${t(score.passed ? 'score.passed' : 'score.notPassed')})`}</span>}
    </span>
  )
}

export default ScoreValue
